import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FlightOffer } from '@app/models/offers/FlightOffer';
import moment from 'moment';

interface DialogData {
    flightOffer: FlightOffer;
    mode: string;
    mobile?: boolean;
}

interface Flug {
    differenceInDays?: string;
    departureAirportName: string;
    estimatedElapsedTime: string;
    departureAirportCode: string;
    departureTime: string;
    departureDate: string;
    departureDateWeek: string;
    arrivalTime: string;
    arrivalDate: string;
    arrivalDateWeek: string;
    arrivalAirportName: string;
    arrivalAirportCode: string;
    flightCarrierCode: string;
    flightCarrierName: string;
    flightNumber: string;
    hiden?: boolean;
}
interface Flights {
    outbound: {
        legList: Flug[];
        directFlug: boolean;
        estimatedElapsedTime: string;
        fromDate: string;
        fromDateWeek: string;
        stopovers: string;
        tariff: string;
        bookingClass: string;
    };
    inbound: {
        legList: Flug[];
        directFlug: boolean;
        fromDate: string;
        fromDateWeek: string;
        estimatedElapsedTime: string;
        stopovers: string;
        tariff: string;
        bookingClass: string;
    };
}

@Component({
    selector: 'app-flugdetail',
    templateUrl: './flugdetail.component.html',
    styleUrls: ['./flugdetail.component.scss'],
    standalone: false
})
export class FlugDetailComponent implements OnInit {
    flightOffer: any;
    myflight: Flights;
    weeks = [
        'SO.',
        'MO.',
        'DI.',
        'MI.',
        'DO.',
        'FR.',
        'SA.',
    ];

    constructor(
        @Inject(MAT_DIALOG_DATA) protected data: DialogData,
        protected cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.initData();
    }

    async initData() {
        this.flightOffer = this.data?.flightOffer;
        this.myflight = {
            inbound: {
                legList: [],
                directFlug: true,
                estimatedElapsedTime: '',
                fromDate: '',
                fromDateWeek: '',
                stopovers: '',
                tariff: '',
                bookingClass: ''
            },
            outbound: {
                legList: [],
                directFlug: true,
                fromDate: '',
                fromDateWeek: '',
                estimatedElapsedTime: '',
                stopovers: '',
                tariff: '',
                bookingClass: ''
            },
        };

        // console.log(this.flightOffer?.flight?.outbound)
        if (this.flightOffer?.flight?.outbound) {
            this.setTrafficsFlight();
        } else if (this.flightOffer.departure) {
            this.setPeakworkFlight();
        }
    }

    async handelError(flight) {
        flight.hiden = true;
    }

    async setTrafficsFlight() {
        if (this.flightOffer?.flight?.inbound) {
            this.myflight.inbound.directFlug = this.flightOffer?.flight?.inboundDirectFlight !== 'false';
            this.myflight.inbound.stopovers = this.flightOffer?.flight?.inbound?.stopovers;
            this.myflight.inbound.tariff = this.flightOffer?.flight?.inbound?.tariff;
            this.myflight.inbound.bookingClass = this.flightOffer?.flight?.inbound?.bookingClass;
            this.myflight.inbound.estimatedElapsedTime = this.flightOffer?.flight?.inbound?.estimatedElapsedTime;
            this.myflight.inbound.fromDate = this.flightOffer?.travelDate?.toDate;
            this.myflight.inbound.fromDateWeek = this.weeks[new Date(this.flightOffer?.travelDate?.toDate).getDay()];
            if (this.flightOffer?.flight?.inbound.legList?.length > 0) {
                for (let i = 0; i < this.flightOffer?.flight?.inbound.legList?.length; i++) {
                    let differenceInDays = '';
                    if (this.flightOffer?.flight?.inbound.legList[i].departureDate?.length > 0 && this.flightOffer?.flight?.inbound.legList[i].arrivalDate?.length > 0) {
                        const Difference_In_Time = new Date(this.flightOffer.flight.inbound.legList[i].arrivalDate).getTime() -
                            new Date(this.flightOffer.flight.inbound.legList[i].departureDate).getTime();
                        differenceInDays = Difference_In_Time > 0 ? (Difference_In_Time / (1000 * 3600 * 24)) + '' : '';
                    }
                    this.myflight.inbound.legList.push({
                        differenceInDays: differenceInDays,
                        flightCarrierCode: this.flightOffer?.flight?.inbound.legList[i].flightCarrierCode,
                        flightCarrierName: this.flightOffer?.flight?.inbound.legList[i].flightCarrierName,
                        flightNumber: this.flightOffer?.flight?.inbound.legList[i].flightNumber,
                        departureAirportCode: this.flightOffer?.flight?.inbound.legList[i].departureAirportCode,
                        estimatedElapsedTime: this.flightOffer?.flight?.inbound.legList[i].estimatedElapsedTime,
                        departureTime: this.flightOffer?.flight?.inbound.legList[i].departureTime,
                        departureDate: this.flightOffer?.flight?.inbound.legList[i].departureDate,
                        departureDateWeek: this.weeks[new Date(this.flightOffer?.flight?.inbound.legList[i].departureDate).getDay()],
                        departureAirportName: this.flightOffer?.flight?.inbound.legList[i].departureAirportName,
                        // arrival
                        arrivalTime: this.flightOffer?.flight?.inbound.legList[i].arrivalTime,
                        arrivalDate: this.flightOffer?.flight?.inbound.legList[i].arrivalDate,
                        arrivalDateWeek: this.weeks[new Date(this.flightOffer?.flight?.inbound.legList[0].arrivalDate).getDay()],
                        arrivalAirportCode: this.flightOffer?.flight?.inbound.legList[i].arrivalAirportCode,
                        arrivalAirportName: this.flightOffer?.flight?.inbound.legList[i].arrivalAirportName,
                    });
                }
            }
        } else {
            this.myflight.inbound = null;
        }

        this.myflight.outbound.directFlug = this.flightOffer?.flight?.outboundDirectFlight !== 'false';
        this.myflight.outbound.stopovers = this.flightOffer?.flight?.outbound?.stopovers;
        this.myflight.outbound.tariff = this.flightOffer?.flight?.outbound?.tariff;
        this.myflight.outbound.bookingClass = this.flightOffer?.flight?.outbound?.bookingClass;
        this.myflight.outbound.estimatedElapsedTime = this.flightOffer?.flight?.outbound?.estimatedElapsedTime;
        this.myflight.outbound.fromDate = this.flightOffer?.travelDate?.fromDate;
        this.myflight.outbound.fromDateWeek = this.weeks[new Date(this.flightOffer?.travelDate?.fromDate).getDay()];
        for (let i = 0; i < this.flightOffer?.flight?.outbound?.legList?.length; i++) {
            let differenceInDays = '';
            if (this.flightOffer?.flight?.outbound?.legList[i].departureDate?.length > 0 && this.flightOffer?.flight?.outbound?.legList[i].arrivalDate?.length > 0) {
                const Difference_In_Time = new Date(this.flightOffer.flight.outbound.legList[i].arrivalDate).getTime() -
                    new Date(this.flightOffer.flight.outbound.legList[i].departureDate).getTime();
                differenceInDays = Difference_In_Time > 0 ? (Difference_In_Time / (1000 * 3600 * 24)) + '' : '';
            }

            this.myflight.outbound.legList.push({
                differenceInDays: differenceInDays,
                flightCarrierCode: this.flightOffer?.flight?.outbound?.legList[i].flightCarrierCode,
                flightCarrierName: this.flightOffer?.flight?.outbound?.legList[i].flightCarrierName,
                flightNumber: this.flightOffer?.flight?.outbound?.legList[i].flightNumber,
                departureAirportCode: this.flightOffer?.flight?.outbound?.legList[i].departureAirportCode,
                estimatedElapsedTime: this.flightOffer?.flight?.outbound?.legList[i].estimatedElapsedTime,
                departureTime: this.flightOffer?.flight?.outbound?.legList[i].departureTime,
                departureDate: this.flightOffer?.flight?.outbound?.legList[i].departureDate,
                departureDateWeek: this.weeks[new Date(this.flightOffer?.flight?.outbound?.legList[i].departureDate).getDay()],
                departureAirportName: this.flightOffer?.flight?.outbound?.legList[i].departureAirportName,
                // arrival
                arrivalTime: this.flightOffer?.flight?.outbound?.legList[i].arrivalTime,
                arrivalDate: this.flightOffer?.flight?.outbound?.legList[i].arrivalDate,
                arrivalDateWeek: this.weeks[new Date(this.flightOffer?.flight?.outbound?.legList[0].arrivalDate).getDay()],
                arrivalAirportCode: this.flightOffer?.flight?.outbound?.legList[i].arrivalAirportCode,
                arrivalAirportName: this.flightOffer?.flight?.outbound?.legList[i].arrivalAirportName,
            });
        }

        // console.log(this.myflight)
    }
    async setPeakworkFlight() {
        if (this.flightOffer?.return) {
            this.myflight.inbound.directFlug = Number(this.flightOffer?.return.stopOver) === 0;;
            this.myflight.inbound.stopovers = this.flightOffer?.return.stopOver;
            // this.myflight.inbound.tariff = this.flightOffer?.flight?.inbound?.tariff;
            this.myflight.inbound.bookingClass = this.flightOffer?.return?.flightClass;
            // this.myflight.inbound.estimatedElapsedTime = (this.flightOffer?.return?.duration / 60).toFixed(0);
            this.myflight.inbound.estimatedElapsedTime = this.flightOffer.return.estimatedElapsedTime;
            this.myflight.inbound.fromDate = moment(this.flightOffer?.return?.departureDateTime).format('YYYY-MM-DD');
            this.myflight.inbound.fromDateWeek = this.weeks[new Date(this.myflight.inbound.fromDate).getDay()];
            if (this.flightOffer.return.flightSegments.length > 0) {
                for (let i = 0; i < this.flightOffer.return.flightSegments?.length; i++) {
                    let differenceInDays = '';
                    if (this.flightOffer.return.flightSegments[i].departureDateTime?.length > 0 && this.flightOffer.return.flightSegments[i].arrivalDateTime?.length > 0) {
                        differenceInDays = moment(this.flightOffer.return.flightSegments[i].arrivalDateTime).diff(moment(this.flightOffer.return.flightSegments[i].departureDateTime), 'days') + '';
                    }
                    this.myflight.inbound.legList.push({
                        differenceInDays: differenceInDays,
                        flightCarrierCode: this.flightOffer.return.flightSegments[i].airline?.code,
                        flightCarrierName: this.flightOffer.return.flightSegments[i].airline?.name,
                        flightNumber: this.flightOffer.return.flightSegments[i].flightNumber,

                        departureAirportCode: this.flightOffer.return.flightSegments[i].departureAirport?.code,
                        estimatedElapsedTime: this.flightOffer.return.flightSegments[i].estimatedElapsedTime,
                        departureTime: moment(this.flightOffer.return.flightSegments[i].departureDateTime).format('HH:mm'),
                        departureDate: moment(this.flightOffer.return.flightSegments[i].departureDateTime).format('YYYY-MM-DD'),
                        departureDateWeek: this.weeks[new Date(this.flightOffer.return.flightSegments[i].departureDateTime).getDay()],
                        departureAirportName: this.flightOffer.return.flightSegments[i].departureAirport.name,
                        // arrival
                        arrivalTime: moment(this.flightOffer.return.flightSegments[i].arrivalDateTime).format('HH:mm'),
                        arrivalDate: moment(this.flightOffer.return.flightSegments[i].arrivalDateTime).format('YYYY-MM-DD'),
                        arrivalDateWeek: this.weeks[new Date(this.flightOffer.return.flightSegments[i].arrivalDateTime).getDay()],
                        arrivalAirportCode: this.flightOffer.return.flightSegments[i].arrivalAirport?.code,
                        arrivalAirportName: this.flightOffer.return.flightSegments[i].arrivalAirport?.name,
                    });
                }
            }
        } else {
            this.myflight.inbound = null;
        }

        this.myflight.outbound.directFlug = Number(this.flightOffer?.departure.stopOver) === 0;;
        this.myflight.outbound.stopovers = this.flightOffer?.departure.stopOver;
        // this.myflight.outbound.tariff = this.flightOffer?.flight?.inbound?.tariff;
        this.myflight.outbound.bookingClass = this.flightOffer?.departure?.flightClass;
        // this.myflight.outbound.estimatedElapsedTime = (this.flightOffer?.departure?.duration / 60).toFixed(0);
        this.myflight.outbound.estimatedElapsedTime = this.flightOffer.departure.estimatedElapsedTime;
        this.myflight.outbound.fromDate = moment(this.flightOffer?.departure?.departureDateTime).format('YYYY-MM-DD');
        this.myflight.outbound.fromDateWeek = this.weeks[new Date(this.myflight.outbound.fromDate).getDay()];
        if (this.flightOffer.departure.flightSegments.length > 0) {
            for (let i = 0; i < this.flightOffer.departure.flightSegments?.length; i++) {
                let differenceInDays = '';
                if (this.flightOffer.departure.flightSegments[i].departureDateTime?.length > 0 && this.flightOffer.departure.flightSegments[i].arrivalDateTime?.length > 0) {
                    differenceInDays = moment(this.flightOffer.departure.flightSegments[i].arrivalDateTime).diff(moment(this.flightOffer.departure.flightSegments[i].departureDateTime), 'days') + '';
                }
                // console.log(this.flightOffer.departure.flightSegments[i].arrivalDateTime, this.flightOffer.departure.flightSegments[i].departureDateTime)
                this.myflight.outbound.legList.push({
                    differenceInDays: differenceInDays,
                    flightCarrierCode: this.flightOffer.departure.flightSegments[i].airline?.code,
                    flightCarrierName: this.flightOffer.departure.flightSegments[i].airline?.name,
                    flightNumber: this.flightOffer.departure.flightSegments[i].flightNumber,

                    departureAirportCode: this.flightOffer.departure.flightSegments[i].departureAirport?.code,
                    estimatedElapsedTime: this.flightOffer.departure.flightSegments[i].estimatedElapsedTime,
                    departureTime: moment(this.flightOffer.departure.flightSegments[i].departureDateTime).format('HH:mm'),
                    departureDate: moment(this.flightOffer.departure.flightSegments[i].departureDateTime).format('YYYY-MM-DD'),
                    departureDateWeek: this.weeks[new Date(this.flightOffer.departure.flightSegments[i].departureDateTime).getDay()],
                    departureAirportName: this.flightOffer.departure.flightSegments[i].departureAirport.name,
                    // arrival
                    arrivalTime: moment(this.flightOffer.departure.flightSegments[i].arrivalDateTime).format('HH:mm'),
                    arrivalDate: moment(this.flightOffer.departure.flightSegments[i].arrivalDateTime).format('YYYY-MM-DD'),
                    arrivalDateWeek: this.weeks[new Date(this.flightOffer.departure.flightSegments[i].arrivalDateTime).getDay()],
                    arrivalAirportCode: this.flightOffer.departure.flightSegments[i].arrivalAirport?.code,
                    arrivalAirportName: this.flightOffer.departure.flightSegments[i].arrivalAirport?.name,
                });
            }
        }
        this.cdr.detectChanges();
    }
}
